import type { FilterModel } from 'src/types'

export const sumFn = <T extends Record<string, number>>(arr: T[], key: keyof T) => arr.reduce((sum, item) => sum + item[key], 0)

// export function groupBy<T extends Record<keyof T, any>> (data: T[], key: keyof T) {
//   // eslint-disable-next-line unicorn/prefer-object-from-entries
//   return data.reduce(
//     (res, currentItem: T) => {
//       const group = currentItem[key]

//       // eslint-disable-next-line unicorn/prefer-spread
//       res[group] = (res[group] || []).concat(currentItem)
//       return res
//     },
//     {} as Record<keyof T, T[]>,
//   )
// }

export const getPercent = (val: number, old?: number) => {
  if (!old) return 0
  if (old === 0) return
  return old > 0
    ? (val - old) / old * 100
    : (val - old) / old * -100
}

// TODO
export const countValid = ({ filters, exclude = [], check = false }: { filters: FilterModel; exclude: string[]; check: boolean }) => Object.entries(filters)
  .filter(([key, value]) => {
    const isArray = Array.isArray(value)
    const isObject = typeof value === 'object'
    const isString = typeof value === 'string'

    const mustExclude = !exclude.includes(key)

    let isValidArray = true
    let isValidObject = true
    let isValidString = true
    let mustCheck = true
    let notNull = true

    if (mustExclude) {
      if (isArray) isValidArray = value.length > 0
      else if (isObject && value) isValidObject = Object.values(value).some(val => !!val)
      if (isString) isValidString = value !== ''
      if (check && value) mustCheck = value[0] !== -1
      if (!isArray) notNull = value !== null
    }

    return mustExclude
      && isValidArray
      && isValidObject
      && isValidString
      && notNull
      && mustCheck
  }).length

// export async function sleep (ms: number) {
//   return new Promise(resolve => setTimeout(resolve, ms))
// }
